import { IContainer } from '../../interface/container';
import { bindStoresReducer } from '../interface';
import register from './register';

function binder(container: IContainer) {
    const registry = register();

    bindStoresReducer(registry, container);
}

export default binder;
